


































import Vue from "vue";
import { ADD_FILE, REMOVE_FILE, RootState } from "@/store/types";
import { mapState, mapMutations } from "vuex";
import FileGroup from "@/components/Form/FileGroup.vue";
import axios from "axios";
import messages from "@/messages.json";
export default Vue.extend({
  name: "FileUpload",

  components: {
    FileGroup,
    Loader: () => import("@/components/UI/Loader.vue"),
    Error: () => import("@/components/Form/Error.vue")
  },

  data: () => ({
    isLoading: false,
    errorMessage: "",
    maxCollectiveFileSize: 10000000
  }),

  computed: {
    ...mapState({
      uploadedFiles: state => (state as RootState).userData.uploadedFiles
    }),

    uploadedFilesSize() {
      return this.uploadedFiles.reduce((acc, file) => acc + file.size, 0);
    }
  },

  methods: {
    ...mapMutations({
      addFile: ADD_FILE,
      removeFile: REMOVE_FILE
    }),

    uploadFiles(files) {
      if (files.length === 0) return;
      for (const file of files) {
        this.uploadFile(file);
      }
    },

    async uploadFile(file) {
      if (file.size + this.uploadedFilesSize >= this.maxCollectiveFileSize) {
        this.errorMessage = messages.error["max_upload_size_exceeded"];
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";
      const formData = new FormData();
      formData.append(`file`, file);

      try {
        const res = await axios.post("file-upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        const file = res.data;
        this.addFile(file);
      } catch (err) {
        const { error } = messages;
        const code = err.response && err.response.data.code;
        if (code && code in error) {
          this.errorMessage = error[code];
        } else {
          this.errorMessage = error["file_upload"];
        }
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
      }

      this.isLoading = false;
    }
  }
});
